import { inject, Injectable } from '@angular/core';

import { Observable, of } from 'rxjs';
import { switchMap, take } from 'rxjs/operators';

import { BillingPlanTier } from '@core/billing-types';
import { AppKind } from '@core/tellent-types';
import { injectTellentAppUrlOpener } from '@core/tellent-util';
import { PricingFeatureObservableModel, ready } from '@recruitee/billing-smart-ui';
import { getProductCodenameFromSubscription, isBillingPlanLegacy } from '@recruitee/billing-util';

@Injectable({
  providedIn: 'root',
})
export class ProductOrder2024Guard {
  private readonly billingModel = inject(PricingFeatureObservableModel);
  private readonly tellentAppUrlOpener = injectTellentAppUrlOpener();

  public canActivate(): Observable<boolean> {
    return this.billingModel.pipe(
      ready,
      switchMap(model => {
        const billingPlanTier = <BillingPlanTier>(
          getProductCodenameFromSubscription(model.subscription)
        );
        const isLegacy = isBillingPlanLegacy(billingPlanTier);
        if (!isLegacy) {
          this.tellentAppUrlOpener(AppKind.TellentAdmin, { id: 'billing' });
          return of(false);
        }
        return of(true);
      }),
      take(1),
    );
  }
}
